<template>
  <v-text-field
    ref="input"
    v-model="maskedValue"
    v-bind="$attrs"
    :label="internalLabel"
    suffix="%"
    validate-on-blur
    data-lpignore="true"
    class=" si-input-number no-spinner"
    :rules="evaluatedRules"
    @change="change"
    @keydown="$emit('keydown', $event)"
  />
</template>

<script>
import element from '@/mixins/element'

function percentAsDecimal (value) {
  if (!value && value !== 0) return 0
  let places = 0
  if (toStr(value).split('.')[1]) {
    places = toStr(value).split('.')[1].length
  }
  return Number((parseFloat(value) / 100).toFixed(places + 2))
}

function onlyNumbersWithDecimal (value) {
  return toStr(value).replace(/[^0-9.]/g, '')
}

function toStr (value) {
  return value || value === 0 ? value.toString() : ''
}

function decimalAsPercent (value) {
  if (!value && value !== 0) return
  let places = 0
  if (toStr(value).split('.')[1]) {
    places = toStr(value).split('.')[1].length
  }
  if (places < 2) places = 2
  return Number((parseFloat(value) * 100).toFixed(places - 2))
}

export default {
  mixins: [ element ],
  props: {
    value: {
      // type: [Number, String, null],
      default: ''
    },
    max: {
      type: Number
    },
    min: {
      type: Number
    },
    autofocus: {
      type: Boolean
    }
  },
  data () {
    return {
      lazyValue: '',
      maskedValue: '',
      requiredRule: v => this.valueValid(v) || `${this.$attrs.label || 'This field'} is required`
    }
  },
  computed: {
    additionalRules () {
      let rules = []
      let max = this.max || 1
      let min = this.min || 0

      rules.push(v => v <= max || `${this.$attrs.label} cannot be greater than ${max * 100}%`)
      rules.push(v => v >= min || `${this.$attrs.label} cannot be less than ${isNaN(min * 100) ? 0 : min * 100}%`)
      return rules
    }
  },
  watch: {
    maskedValue (v) {
      if (v || v === 0) {
        if (onlyNumbersWithDecimal(v).toString() !== v.toString()) {
          this.$nextTick(() => {
            this.maskedValue = onlyNumbersWithDecimal(v) || '' // needs to be in next tick as v-text-field internal update was overwriting
          })
        }
      }
      this.emit('input', v)
    },
    value: {
      immediate: true,
      handler (v) {
        if (decimalAsPercent(v) !== this.maskedValue) {
          let formattedNumber = parseFloat(decimalAsPercent(v))
          this.maskedValue = !isNaN(formattedNumber) ? formattedNumber : ''
        }
      }
    }
  },
  methods: {
    change (v) {
      this.emit('change', v)
    },
    emit (evt, v) {
      let value = v === '' ? '' : parseFloat(percentAsDecimal(onlyNumbersWithDecimal(v)))
      this.lazyValue = value
      this.$emit(evt, value)
    }
  }
}
</script>

<style>

</style>
